import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	async getFactoris() {
		const sqlId = 'custDescSql_1';
		const commCdType = 'FACTORY_CD';
		try {
			const response = await client.get(`${BASE_URL}/comm/v1/customCodesDesc?sqlId=${sqlId}&commCdType=${commCdType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**모든 라인을 가져온다*/
	async getLines() {
		const sqlId = 'custDescSql_1';
		const commCdType = 'LINE_CD';
		try {
			const response = await client.get(`${BASE_URL}/comm/v1/customCodesDesc?sqlId=${sqlId}&commCdType=${commCdType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**필터된 라인만을 가져온다 param type : object */
	async getLinesFiltered(cdDesc) {
		const sqlId = 'custDescSql_1';
		const commCdType = 'LINE_CD';
		try {
			const response = await client.get(`${BASE_URL}/comm/v1/customCodesDesc?sqlId=${sqlId}&commCdType=${commCdType}&cdDesc=${cdDesc}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/** open other tab 실 */
	async selectOne(gqmsSeq) {
		let url = `${BASE_URL}/uploadForm/v1/uploadForms/${gqmsSeq}`;
		try {
			const response = await client.get(url);
			return (response && response.data) || null;
		} catch (error) {
			return console.log(error);
		}
	},
	async fileDownload({ params }) {
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			return error.message || error.response;
		}
	},
	saveFreeForm: ({ formData }) => {
		let url = `${BASE_URL}/uploadForm/v1/status/2/uploadForms`;
		// for (var pair of formData.entries()) {
		// 	console.log(pair[0] + ', ' + pair[1]);
		// }
		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => console.log(error));
	},
	// 삭제 버튼을 클릭했을때
	deleteFreeForm: params => {
		const { key, value } = params;
		let url = `${BASE_URL}/uploadForm/v1/status/3/uploadForms?gqmsSeq=${value}`;
		return client
			.post(url)
			.then(response => (response && response.data) || null)
			.catch(error => console.log(error));
	}
};
